import * as Sentry from '@sentry/react';

import { getSettings  } from '../config';

const isEnabled = () => Boolean(getSettings().sentryDsn);

const normalizeError = (err) =>
  err instanceof Error
    ? err
    : new Error(typeof err === 'string' ? err : JSON.stringify(err));

export const logError = (error, context = {}) => {
   try {
  const e = normalizeError(error);
  console.error(e, context);

  if (!isEnabled()) return;

  Sentry.withScope((scope) => {
    if (context && Object.keys(context).length > 0) {
      scope.setContext('extra_info', context);
    }
    scope.setTag('service', getSettings.metadataName);
    scope.setLevel('error');
    Sentry.captureException(e);
  }
  );
    } catch (loggingError) {
    console.error('Logging failed', loggingError);
  }
};

export const logWarning = (message, context = {}) => {
  try{
  console.warn(message, context);

  if (!isEnabled()) return;

  Sentry.withScope((scope) => {
    if (context && Object.keys(context).length > 0) {
      scope.setContext('extra_info', context);
    }
    scope.setTag('service', getSettings.metadataName);
    scope.setLevel('warning');
    Sentry.captureMessage(String(message));
  });
  } catch (loggingError) {
    console.error('Logging failed', loggingError);
  }
};

export const logInfo = (message, context = {}) => {
  console.log(message, context);
  // dont send info level logs to sentry
};
